export enum ACTION_TYPES {
    FETCH_REQUEST = '@@FETCH_REQUEST',
    FETCH_SUCCESS = '@@FETCH_SUCCESS',
    FETCH_ERROR = '@@FETCH_ERROR',

    SET_VIEWPORT = '@@SET_VIEWPORT',
    SET_EDITING = '@@SET_EDITING',
    SET_MAP_STYLE = '@@SET_MAP_STYLE',
    SET_LAYER_IDS = '@@SET_LAYER_IDS',
    SET_SINGLE_POINT = '@@SET_SINGLE_POINT',

    TOGGLE_LAYER_LIST = '@@TOGGLE_LAYER_LIST',
    TOGGLE_CONTACT_TABLE = '@@TOGGLE_CONTACT_TABLE',

    SET_POPUP_INFO = '@@SET_POPUP_INFO',
    SET_USER_LOCATION = '@@SET_USER_LOCATION',
    SET_ACTIVE_PANEL = '@@SET_ACTIVE_PANEL',

    SET_USER_INFO = '@@SET_USER_INFO',

    CREATE_MEASUREMENT_LAYER = '@@CREATE_MEASUREMENT_LAYER',

    /** http **/

    FETCH_STYLE = '@@FETCH_STYLE',
    FETCH_STYLE_SUCCESS = '@@FETCH_STYLE_SUCCESS',
    FETCH_STYLE_ERROR = '@@FETCH_STYLE_ERROR',

    FETCH_LAYERS = '@@FETCH_LAYERS',
    FETCH_LAYERS_SUCCESS = '@@FETCH_LAYERS_SUCCESS',
    FETCH_LAYERS_ERROR = '@@FETCH_LAYERS_ERROR',

    FETCH_POINT_LAYER = '@@FETCH_POINT_LAYER',
    FETCH_POINT_LAYER_SUCCESS = '@@FETCH_POINT_LAYER_SUCCESS',
    FETCH_POINT_LAYER_ERROR = '@@FETCH_POINT_LAYER_ERROR',

    FETCH_POLYGON_LAYER = '@@FETCH_POLYGON_LAYER',
    FETCH_POLYGON_LAYER_SUCCESS = '@@FETCH_POLYGON_LAYER _SUCCESS',
    FETCH_POLYGON_LAYER_ERROR = '@@FETCH_POLYGON_LAYER_ERROR',

    FETCH_GEOMETRY_LAYER = '@@FETCH_GEOMETRY_LAYER',
    FETCH_GEOMETRY_LAYER_SUCCESS = '@@FETCH_GEOMETRY_LAYER_SUCCESS',
    FETCH_GEOMETRY_LAYER_ERROR = '@@FETCH_GEOMETRY_LAYER_ERROR',

    FETCH_ALL_GEOMETRY_LAYER_SUCCESS = '@@FETCH_ALL_GEOMETRY_LAYER_SUCCESS',


    /** mutations **/

    UPDATE_LAYER = '@@UPDATE_LAYER',
    UPDATE_LAYER_SUCCESS = '@@UPDATE_LAYER_SUCCESS',
    UPDATE_LAYER_ERROR = '@@UPDATE_LAYER_ERROR',

    UPDATE_ENTITY = '@@UPDATE_ENTITY',
    UPDATE_ENTITY_SUCCESS = '@@UPDATE_ENTITY_SUCCESS',
    UPDATE_ENTITY_ERROR = '@@UPDATE_ENTITY_ERROR',

    UPDATE_ENTITY_GEOMETRY = '@@UPDATE_ENTITY_GEOMETRY',
    UPDATE_ENTITY_GEOMETRY_SUCCESS = '@@UPDATE_ENTITY_GEOMETRY_SUCCESS',
    UPDATE_ENTITY_GEOMETRY_ERROR = '@@UPDATE_ENTITY_GEOMETRY_ERROR',
    UPDATE_ENTITY_GEOMETRY_CANCEL = '@@UPDATE_ENTITY_GEOMETRY_CANCEL',


    DELETE_ENTITY = '@@DELETE_ENTITY',
    DELETE_ENTITY_SUCCESS = '@@DELETE_ENTITY_SUCCESS',
    DELETE_ENTITY_ERROR = '@@DELETE_ENTITY_ERROR',

    DELETE_LAYER = '@@DELETE_LAYER',
    DELETE_LAYER_SUCCESS = '@@DELETE_LAYER_SUCCESS',
    DELETE_LAYER_ERROR = '@@DELETE_LAYER_ERROR',


    CREATE_ENTITY = '@@CREATE_ENTITY',
    CREATE_ENTITY_SUCCESS = '@@CREATE_ENTITY_SUCCESS',
    CREATE_ENTITY_ERROR = '@@CREATE_ENTITY_ERROR',

    CREATE_ENTITY_GEOMETRY = '@@CREATE_ENTITY_GEOMETRY',
    CREATE_ENTITY_GEOMETRY_SUCCESS = '@@CREATE_ENTITY_GEOMETRY_SUCCESS',
    CREATE_ENTITY_GEOMETRY_ERROR = '@@CREATE_ENTITY_GEOMETRY_ERROR',

    CREATE_LAYER = '@@CREATE_LAYER',
    CREATE_LAYER_SUCCESS = '@@CREATE_LAYER_SUCCESS',
    CREATE_LAYER_ERROR = '@@CREATE_LAYER_ERROR',

    CREATE_FEATURE = '@@CREATE_FEATURE',
    CREATE_FEATURE_SUCCESS = '@@CREATE_FEATURE_SUCCESS',
    CREATE_FEATURE_ERROR = '@@CREATE_FEATURE_ERROR',

    UPDATE_FEATURE = '@@UPDATE_FEATURE',
    UPDATE_FEATURE_SUCCESS = '@@UPDATE_FEATURE_SUCCESS',
    UPDATE_FEATURE_ERROR = '@@UPDATE_FEATURE_ERROR',

    UPDATE_POLYGON = '@@UPDATE_POLYGON',
    UPDATE_POLYGON_SUCCESS = '@@UPDATE_POLYGON_SUCCESS',
    UPDATE_POLYGON_ERROR = '@@UPDATE_POLYGON_ERROR',

    UPDATE_POINT = '@@UPDATE_POINT',
    UPDATE_POINT_SUCCESS = '@@UPDATE_POINT_SUCCESS',
    UPDATE_POINT_ERROR = '@@UPDATE_POINT_ERROR',


    CREATE_POLYGON = '@@CREATE_POLYGON',
    CREATE_POLYGON_SUCCESS = '@@CREATE_POLYGON_SUCCESS',
    CREATE_POLYGON_ERROR = '@@CREATE_POLYGON_ERROR',
    
    CREATE_POINT = '@@CREATE_POINT',
    CREATE_POINT_SUCCESS = '@@CREATE_POINT_SUCCESS',
    CREATE_POINT_ERROR = '@@CREATE_POINT_ERROR',

    /** end mutations **/

    EDIT_FEATURE = '@@EDIT_FEATURE',
    DELETE_FEATURE = '@@DELETE_FEATURE',
    SAVE_FEATURE = '@@SAVE_FEATURE',

    PAN_TO_FEATURE = '@@PAN_TO_FEATURE',

    TOGGLE_LAYER_VISIBILITY = '@@TOGGLE_LAYER_VISIBILITY',
    TOGGLE_FEATURE_VISIBILITY = '@@TOGGLE_FEATURE_VISIBILITY',

    SELECT_FEATURE = '@@SELECT_FEATURE',
    SELECT_FEATURES = '@@SELECT_FEATURES',
    /**   **/
}

export const createAction = (type: ACTION_TYPES, payload: any) => ({
    type,
    payload
});
